const CommonLogoConfig = {
  leaderboard: '/products/banners/assets/logos/expedia-inline.svg',
  'medium-rectangle': '/products/banners/assets/logos/expedia-inline.svg',
  'wide-skyscraper': '/products/banners/assets/logos/expedia-stacked.svg',
};

const ExpediaLogoConfig = {
  'us-expedia': CommonLogoConfig,
  'uk-expedia': CommonLogoConfig,
  'ca-expedia': CommonLogoConfig,
  'au-expedia': CommonLogoConfig,
  'fr-expedia': CommonLogoConfig,
  'de-expedia': CommonLogoConfig,
  'mx-expedia': CommonLogoConfig,
  'jp-expedia': CommonLogoConfig,
  'kr-expedia': CommonLogoConfig,
  'hk-expedia': CommonLogoConfig,
  'sg-expedia': CommonLogoConfig,
  'nz-expedia': CommonLogoConfig,
};

export { ExpediaLogoConfig };
